import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'mobile-navbar',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './mobile-navbar.component.html',
  styleUrl: './mobile-navbar.component.scss',
})
export class MobileNavbarComponent {
  @Output()
  onLeftButtonClick = new EventEmitter<void>();

  @Input()
  title: string = '';

  @Input()
  leftButtonIcon: string = 'menu';

  @Input()
  rightButtonIcon: string = '';
}
